// src/pages/documents/RulesFI.js
          //this will be painful to update
import React from 'react';

const Environmental_plan = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Integralis environmental plan</h1>
          <p>Updated 2025</p>
          
        </div>
      </section>
      <section className="content-section">
        <div className="container">

          <div className="rule-card">
<p>The purpose of this document is to reduce Integralis’ direct negative
environmental impact and promote environmental consciousness among its
members. Each new board must aim to implement the environmental plan.
Changes to the environmental plan must be approved at statutory meetings.
</p>
<h2>The person in charge of environmental affairs</h2>
<p>Integralis will appoint an environmental officer for each board term. The
environmental officer oversees updating the environmental plan. Furthermore,
their duties include:
</p><ol>
  <li>Making suggestions on how to make Integralis’ activities more
environmentally friendly.</li>
<li>Monitoring the realization of this environmental plan.</li>
<li>Strengthening the awareness of environmental issues within Integralis.</li>
<li> Taking part in environmental campaigns for student organizations on
behalf of Integralis.</li>
</ol>

<h2>Acquisitions</h2>
<p>Integralis prioritizes acquiring second-hand items whenever possible. If
unavailable, sustainable new products will be considered. Integralis aims to
acquire sustainable merchandise (e.g. hoodies).
</p>

<h2>Reducing waste and sorting</h2>
<p>Integralis will promote the use of the waste separation stations provided by the
University of Helsinki both in its student room “Hideout” and on the premises of
the University. Integralis aims to minimize the use of disposable dishes, cutlery
and related products and provide reusable ones.</p>

<h2>Cleaning</h2>
<p>Integralis will regularly clean its student room “Hideout” and create a cleaning
plan to keep the furniture and room in good condition for as long as possible.</p>

<h2>Events</h2>
<p>The environmental officer must be included in the planning of Integralis’ events
to ensure the realization of this plan.</p>
<p>Events planned by Integralis must be accessible by public transport or through
organized group transportation.</p>
<p>Following the dress code at Integralis’ events should be possible without having
to buy new or discard existing outfits. Integralis aims to use reusable decorations
(e.g. fairy lights) and rent decorations from other organizations (e.g., HYY nakki- ja
tavaravaihto FB group) to reduce waste. Furthermore, Integralis aims to improve
waste recycling at events.</p>
<p>Integralis aims to create a songbook to reduce the need for disposable printed
songbooks, such as those used at academic table parties.</p>
<p>Integralis must ensure that noise levels at events are kept at an adequate level.</p>

<h2>Serving food</h2>
<p>Integralis will serve a fully vegan menu at larger events such as academic table
parties and anniversary balls. For all other events, both vegan and non-vegan
options will be provided, ensuring that a vegan-equivalent alternative is always
available. Before each event, we ask attendees about their dietary preferences and
do our best to accommodate them. </p><p>While vegan options will be prioritized for
their environmental benefits, dietary needs will be considered to ensure
inclusivity. The environmental officer can be consulted for recipe ideas. Integralis
aims to use reusable tableware, and any leftover food will be distributed among
members to minimize waste.
</p>

<h2>Meetings</h2>
<p>Integralis will hold only paperless meetings to reduce paper waste.</p>

<h2>Energy consumption and emissions</h2>
<p>Integralis’ preferred mode of transportation is public transportation. If this is not
possible, Integralis aims to maximize carpooling or organized transportation.</p>

<br></br>
<p>This document was approved at the statutory meeting on the 19th of March 2025.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Environmental_plan;

